const faqs = [
  {
    q: '91在线视频是否需要注册才能观看？',
    a: '无需注册即可畅享大部分精选内容。我们致力于提供低门槛、高质量的在线观看体验，打开即看、即点即播。注册账号后可享受收藏、历史记录等个性化功能。',
  },
  {
    q: '平台上的视频画质如何？是否支持高清播放？',
    a: '91在线视频全线支持高清播放，大部分精品影视资源提供1080P及以上画质选项。我们采用智能码率适配技术，根据您的网络状况自动调节清晰度，确保流畅不缓冲的观影体验。',
  },
  {
    q: '内容多久更新一次？',
    a: '我们保持每日更新节奏，热门推荐清单、专题合集和精选视频栏目均有专人维护。新片速递频道第一时间同步最新资源，高分电影库也在持续扩充中。',
  },
  {
    q: '支持哪些设备观看？',
    a: '91在线视频全面适配桌面端、平板和移动端设备。您可以通过浏览器直接访问，也可下载我们的移动客户端，在手机或平板上享受专属优化的观看界面。',
  },
  {
    q: '如何找到我想看的影片？',
    a: '我们提供多种发现路径：热门话题标签帮您按兴趣筛选、专题合集按主题归类、排行榜单展示热度趋势，还有精选推荐栏目的人工编辑精选。搜索功能支持影片名、导演和演员快速定位。',
  },
  {
    q: '平台内容是免费的吗？',
    a: '91在线视频大部分精品影视内容均可免费在线观看，我们通过精选推荐和专题策划为观众提供高质量的免费观影服务。部分独家内容可能设有会员专享，具体以页面标示为准。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">
            关于91在线视频，您想了解的一切
          </p>
        </div>

        <div className="space-y-3">
          {faqs.slice(0, 6).map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}